<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="childrenLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Dzieci</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select v-model="selectedYear"  class="choose_year" :items="lookups.years" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchChildren"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 
                
                <v-spacer></v-spacer>
                <v-dialog v-if="user.permissions['dictionary'] >= 20" v-model="dialogImport" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" size="24" class="mr-2" color="primary" >mdi-database-import</v-icon>
                  </template>
                  <import-children @close="closeImport"></import-children>
                </v-dialog>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 20"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-checkbox v-model="showDeleted" class="mt-5" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-dialog v-if="user.permissions['dictionary'] >= 10" v-model="dialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="childAddStatus===1 || childEditLoadStatus===1 || childEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>                   
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.name" :error-messages="nameErrors" required @input="$v.editedItem.name.$touch()"  @blur="$v.editedItem.name.$touch()" label="Imię"></v-text-field>                            
                            </v-col>
                             <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.surname" :error-messages="surnameErrors" required @input="$v.editedItem.surname.$touch()"  @blur="$v.editedItem.surname.$touch()" label="Nazwisko"></v-text-field>                            
                            </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.birth_year"
                              :error-messages="birth_yearErrors"
                              required
                              @input="$v.editedItem.birth_year.$touch()"
                              @blur="$v.editedItem.birth_year.$touch()"
                              hint="RRRR"
                              label="Rocznik"
                              counter="4"
                            ></v-text-field>
                          </v-col>

                           <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.course_id"
                            :items="lookups.courses"
                            label="Grupa"
                          ></v-select>
                        </v-col>

                          <v-col class="col-12"><v-checkbox single-line hide-details="auto" v-model="editedItem.pickup" label="Odbiór dziecka wymaga wskazania osoby upoważnionej"></v-checkbox></v-col>

                          </v-row>
                          
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.course="{ item }">
              <span v-if="item.courses" :class="item.courses.status?'':'deleted'">{{item.courses.name}}</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.status && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="reactivateItem(item)"
                  >
                    mdi-delete-restore
                  </v-icon>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                </template> 
            <template v-slot:item.details="{ item }">       
                <v-btn :to="{name:'slowniki.dziecko',params:{id:item.id,year_id:options.selectedYear}}" color="primary" x-small>Detale</v-btn>
            </template> 

             <template v-slot:item.owners="{ item }">
                <div v-html='item.owners'/>
            </template>

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && childrenLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadChildren" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadChildren" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

        </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>

</template>

<script>
  import confirm from '../components/Confirm'
  import minLength from "vuelidate/lib/validators/minLength";
  import maxLength from 'vuelidate/lib/validators/maxLength'
  import required from 'vuelidate/lib/validators/required'
  import numeric from "vuelidate/lib/validators/numeric";
  import ImportChildren from "../components/ImportChildren"

  export default {
    components:{
      confirm,
      ImportChildren
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      dialogImport:false,
      itemEditing:false,
      search:'',
      itemWasDefault:false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Imię', value: 'name',filterable:true,filterColumn:"name",display:true },
        { text: 'Nazwisko', value: 'surname',filterable:true,filterColumn:"surname",display:true },
        { text: 'Rocznik', value: 'birth_year',filterable:true,filterColumn:"birth_year",display:true },
        { text: "Grupa", value: "course",sortable: false,filterable:true,filterColumn:"courses.name",display:true },
        { text: "Rodzic", value: "owners",sortable: false,filterable:true,filterColumn:"owners.name",display:true },
        { text: "Rodzic", value: "owners.mobile",sortable: false,filterable:true,filterColumn:"owners.mobile",display:false },
        { text: 'Status', value: 'status',filterable:false,display:true },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false,display:true },
        { text: '', value: 'details', sortable: false,filterable:false,display:true},
      ],
    }),
    validations: {
      editedItem:{
        name: {
          required,
        },
        surname: {
          required,
        },
        birth_year:{
          required,
          numeric,
          maxLength:maxLength(4),
          minLength:minLength(4),
        },
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      childEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      childAddStatus(val){
        if(val===2){
          this.close();
          this.closeImport();
          this.componentKey += 1;
        }
      },
      childDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getChildOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setChildOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getChildOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          this.options = currentOptions;
          this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedYear} );
          this.$store.dispatch( 'loadRateLookup', {year_id:this.options.selectedYear} );
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getChildOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getChildEdit;
      },
      tableItems(){
        return this.$store.getters.getChildren;
      },
      childrenLoadStatus(){
        return this.$store.getters.getChildrenLoadStatus;
      },
      childEditLoadStatus(){
        return this.$store.getters.getChildEditLoadStatus
      },
      childEditStatus(){
        return this.$store.getters.getChildEditStatus();
      },
      childEditText(){
        return this.$store.getters.getChildEditText
      },
      childAddStatus(){
        return this.$store.getters.getChildAddStatus();
      },
      childAddText(){
        return this.$store.getters.getChildAddText;
      },
      childDeleteStatus(){
        return this.$store.getters.getChildDeleteStatus();
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]

        if(!this.showDeleted && this.user.permissions['dictionary'] <= 5) return localHeaders.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['dictionary'] <= 5) return localHeaders.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return localHeaders.filter(h => h.value!=='status')
        else return localHeaders
      },
      formTitle () {
        return !this.itemEditing ? 'Nowe dziecko' : 'Edycja dziecka'
      },
     nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.name.$dirty) return errors;
      !this.$v.editedItem.name.required && errors.push("Imię jest wymagane");
      return errors;
      },
    surnameErrors() {
        const errors = [];
        if (!this.$v.editedItem.surname.$dirty) return errors;
        !this.$v.editedItem.surname.required &&
          errors.push("Nazwisko jest wymagane");
        return errors;
      },
    birth_yearErrors() {
      const errors = [];
      if (!this.$v.editedItem.birth_year.$dirty) return errors;
      !this.$v.editedItem.birth_year.required && errors.push("Rocznik jest wymagany");
      !this.$v.editedItem.birth_year.numeric && errors.push("Proszę wpisać poprawny rocznik");
      !this.$v.editedItem.birth_year.minLength && errors.push("Proszę wpisać poprawny rocznik");
      !this.$v.editedItem.birth_year.maxLength && errors.push("Proszę wpisać poprawny rocznik");
      return errors;
    },
     
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadChildren();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadChildren();
        }, 2000)
      }
    },
    methods: {
      loadChildren(){
        this.search='';
        this.$store.dispatch( 'loadChildren' );
        this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedYear} );
        //dispatch("loadRateLookup",{year_id:response.data.year_id});
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreChildren' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editChildReactivate',{slug:item.id, year_id: this.options.selectedYear});
      },
      editItem (item) {
        this.itemWasMain = item.main;
        this.itemEditing = true
        this.$store.dispatch( 'loadChildEdit', {slug: item.id, year_id: this.options.selectedYear});  
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć dziecko?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteChild', {slug:  item.id, year_id: this.options.selectedYear});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać dziecko na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteChild', {slug:  item.id, year_id: this.options.selectedYear});
            }
        })
      },
      searchChildren(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchChildren',{filterableHeaders:filterableHeaders,q:this.search.replace(/,/, ".")});
        }
      },
      importChildren(){

      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadChildEditDefault'); 
          this.$store.dispatch( 'loadChildAddDefault');
          this.itemEditing = false
        }, 300)
      },
      closeImport(){
        this.dialogImport = false
         this.$v.$reset()
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editChild', {
                slug: this.editedItem.id,
                name:  this.editedItem.name,
                surname: this.editedItem.surname,
                birth_year: this.editedItem.birth_year,
                note: this.editedItem.note,
                pickup: this.editedItem.pickup,
                year_id: this.options.selectedYear,
                course_id: this.editedItem.course_id
              });
            } else {//new item
              this.$store.dispatch( 'addChild', {
                name:  this.editedItem.name,
                surname: this.editedItem.surname,
                birth_year: this.editedItem.birth_year,
                note: this.editedItem.note,
                pickup: this.editedItem.pickup,
                year_id: this.options.selectedYear,
                course_id: this.editedItem.course_id
              });

            }
        }
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
</style>